import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=63a9e98f&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a9e98f')) {
      api.createRecord('63a9e98f', component.options)
    } else {
      api.reload('63a9e98f', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=63a9e98f&", function () {
      api.rerender('63a9e98f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4v7EtJXvl4QHn/JS/comp/cancellationPolicy.vue"
export default component.exports